import { render, staticRenderFns } from "./QuotePrompt.vue?vue&type=template&id=f5710e76&scoped=true&"
import script from "./QuotePrompt.vue?vue&type=script&lang=js&"
export * from "./QuotePrompt.vue?vue&type=script&lang=js&"
import style0 from "./QuotePrompt.vue?vue&type=style&index=0&id=f5710e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5710e76",
  null
  
)

export default component.exports